import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import cx from "classnames";
import styles from "../Stepper.module.scss";
const Step = ({ current, stepNumber, title, className = "", handlePrev, canAccessPrev, canMoveToStep = true, }) => {
    const isPrev = stepNumber - current === -1;
    const isActive = current === stepNumber;
    const isPassed = stepNumber - current < -1;
    const onClickPrev = (e) => {
        e.preventDefault();
        canMoveToStep && isPrev && canAccessPrev && handlePrev();
    };
    return (_jsxs("div", { className: cx(styles.step, className, { active: isActive, prevStep: isPrev, passedStep: isPassed }), "data-testid": "stepContainer", children: [_jsx("div", { className: `${styles.number}`, children: _jsx("button", { "data-testid": "stepNumberButton", className: styles.numberContent, onClick: onClickPrev, disabled: !isPrev || !canAccessPrev || !canMoveToStep, children: stepNumber }) }), _jsx("button", { "data-testid": "stepper-label", disabled: !isPrev || !canAccessPrev || !canMoveToStep, onClick: onClickPrev, className: styles.title, children: title })] }));
};
export default memo(Step);
